import { h, render } from 'preact'
import { App } from './components/App'
/** @jsx h */

const container = document.querySelector('.js-quiz-app')
if (container !== null) {
  render(<App {...QuizSettings} />, container)
}



// WEBPACK FOOTER //
// ./src/js/quiz/index.js